import styled from 'styled-components';

export const Flex = styled.div<{
    gap?:number,
    flexDirection?:'row'|'column',
    justifyContent?:'stretch' | 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly',
    alignItems?:'stretch' | 'flex-start' | 'flex-end' | 'center' | 'space-between',
    flexWrap?:'wrap'| 'nowrap' | 'wrap-reverse',
    textAlign?:string,
    width?: string,
    marginTop?: number,
    marginRight?: number,
    marginBotttom?: number,
    marginLeft?: number,
    grow?:string,
}>`
    display:flex;
    flex-direction: ${props => props.flexDirection || 'row' };
    ${props => props.justifyContent && `justify-content: ${props.justifyContent}`};
    align-items:${props => props.alignItems!==undefined ? props.alignItems : 'stretch'};
    gap:${props => props.gap===undefined ? '0px' : (props.gap +'px')};
    flex-wrap:${props => props.flexWrap===undefined ? 'nowrap' : props.flexWrap};
    ${props => props.textAlign && `text-align: ${props.textAlign}`};
    ${props => props.width && `width: ${props.width};`};
    flex-grow: ${props => props.grow ? props.grow : undefined };

    ${props => props.marginTop && `margin-top: ${props.marginTop}px;`};
    ${props => props.marginRight && `margin-right: ${props.marginRight}px;`};
    ${props => props.marginBotttom && `margin-bottom: ${props.marginBotttom}px;`};
    ${props => props.marginLeft && `margin-left: ${props.marginLeft}px;`};
`;

export const FlexItem = styled.div<{ 
    alignSelf?:string,
    flexGrow?: '0' | '1' | '2' | '3' | '4',
    justifySelf?:string,
    textAlign?: string,    
    width?: string
}>` 
    ${props => props.alignSelf && `align-self: ${props.alignSelf}`};
    flex-grow: ${props => props.flexGrow ? props.flexGrow : '0' };
    ${props => props.justifySelf && `justify-self: ${props.justifySelf}`};
    ${props => props.textAlign && `text-align: ${props.textAlign}`};
    ${props => props.width && `width: ${props.width};`};
`;


export const Grid = styled.div<{
    gap?:number,
    gridTemplateColumns?:number,
    gridTemplateRows?:number
}>`
    display:grid;
    grid-template-columns: '1fr';
    grid-template-rows: '1fr';
    gap: ${props => props.gap ? `${props.gap}px` : '0px'};

    @media (min-width: 768px) {
        grid-template-columns: ${props => props.gridTemplateColumns ? `repeat(${props.gridTemplateColumns}, minmax(0px, 1fr))` : '1fr' };
        grid-template-rows: ${props => props.gridTemplateRows ? `repeat(${props.gridTemplateRows}, minmax(0px, 1fr))` : '1fr' };
    }
`;
